<template>
  <div class="grey-box">
    <div>

      <strong>Save time, upload you Shopify orders!</strong>
      <p style="font-weight: normal; margin: 0">Uploading your <a href="https://help.shopify.com/en/manual/orders/export-orders" rel="noreferrer" target="_blank">Shopify orders CSV</a> will automatically
        create shipments with recipient information.</p>
    </div>
    <div class="grey-box__right">
      <form>
        <input
            id="csvUpload"
            type="file"
            name="csv"
            accept=".csv"
            @change="parseCsv"
        >
        <label for="csvUpload">Upload File</label>
      </form>
    </div>
  </div>
</template>

<style scoped>
form {
  text-align: right;
}

label {
  font-weight: normal;
  border-radius: 3px;
  border: 1px solid #929292;
  background: #F2F2F2;
  display: flex;
  padding: 6px 6px;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  line-height: 1;
  transition: 0.3s;
  white-space: nowrap;
}

label:hover{
  background: #fff;
}

#csvUpload {
  display: none;
}

.grey-box {
  background: #FBFBFB;
  border: 1px solid #C8C8C8;
  padding: 16px;
  display: flex;
  gap: 32px;
  margin-bottom: 32px;
}

.grey-box__right {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

@media (max-width: 600px) {
  .grey-box {
    flex-direction: column;
  }

  .grey-box__divider {
    width: 100%;
    height: 1px;
  }

  .grey-box__half {
    width: 100%;
  }
}
</style>


<script>
import Papa from 'papaparse'
import {useOrderStore} from "../stores/order";
import {storeToRefs} from "pinia";

export default {
  setup: () => {
    const useOrder = useOrderStore()

    const {addShipment, deleteUnusedShipments, updateOrder} = useOrder
    const {shipments} = storeToRefs(useOrder)

    return {
      addShipment,
      deleteUnusedShipments,
      shipments,
      updateOrder
    }
  },
  components: {},
  props: {},
  data: () => ({}),
  methods: {
    parseCsv(event) {
      let file = event.target.files[0]
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async (results) => {
          if(results.errors.length){
            const err = results.errors.map(item => {
              return `On row number ${item.row} the following error occurred: \n${item.message}`;
            });

            alert("There was an error parsing your csv file: \n" + err.join('\n\n'))
          }
          // We don't need blank shipments if they are importing
          this.deleteUnusedShipments()

          let prevId = null
          const shipments = results.data.reduce((prev, item) => {
            if (prevId === item['Name']) {
              prev[prev.length - 1]['Lineitem name'] += ' ' + item['Lineitem name'].replace(/[^a-zA-Z\s\d\-0-9\.]/img, '');
              return prev;
            }

            item['Shipping Country'] = item['Shipping Country'] === 'USA' ? 'US' : item['Shipping Country'];

            if (item['Shipping Country'] !== 'US') {
              return prev;
            }

            prevId = item['Name'];
            prev.push(item)
            return prev;
          }, [])

          shipments.forEach((shipment) => {
            shipment['Subtotal'] = shipment['Subtotal'] !== null ? parseFloat(shipment['Subtotal']) : 0;

            if (shipment['Currency'] === 'CAD') {
              shipment['Subtotal'] = shipment['Subtotal'] * 0.75
            } else if (shipment['Currency'] !== 'USD') {
              shipment['Subtotal'] = null;
            }

            let data = {
              meta: shipment['Name'],
              initially_expanded: true,
              address_to: {
                name: shipment['Shipping Name'],
                street1: shipment['Shipping Address1'],
                street2: shipment['Shipping Address2'],
                phone: shipment['Shipping Phone'],
                city: shipment['Shipping City'],
                state: shipment['Shipping Province'],
                zip: shipment['Shipping Zip'],
                country: 'US',
              },
            }
            const store = this.addShipment(data, [
              {
                description: shipment['Lineitem name'],
                value: parseFloat(shipment['Subtotal']),
              }
            ])
          })
        }
      })
    }
  }
}
</script>
